/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import classnames from 'classnames';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const useStyles = makeStyles((theme) => ({
  dropzone: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.grey[500],
    border: '3px dashed transparent',
    padding: theme.spacing(4),
    transition: 'border-color 0.2s',
    '&:focus': {
      outline: 'none',
    },
  },
  dropzoneActive: {
    borderColor: theme.palette.primary.main,
  },
  cloudIcon: {
    transition: 'color 0.2s',
    fontSize: 72,
  },
  cloudIconActive: {
    color: theme.palette.primary.main,
  },
}));

const Dropzone = (props) => {
  const classes = useStyles();
  const { Icon, className, message, accept, onDropFile } = props;

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept,
    noClick: true,
    noKeyboard: true,
    disablePreview: true,
    multiple: false,
    onDrop(files) {
      const [file] = files;
      if (!file) return;
      onDropFile(file);
    },
  });

  return (
    <Box className={className}>
      <Box
        {...getRootProps()}
        className={classnames(classes.dropzone, {
          [classes.dropzoneActive]: isDragActive,
        })}
      >
        <input {...getInputProps()} />
        <Icon
          className={classnames(classes.cloudIcon, {
            [classes.cloudIconActive]: isDragActive,
          })}
        />
        <Typography variant="subtitle1" color="inherit">
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

Dropzone.propTypes = {
  className: PropTypes.string,
  Icon: PropTypes.object,
  message: PropTypes.node,
  accept: PropTypes.string,
  onDropFile: PropTypes.func.isRequired,
};

Dropzone.defaultProps = {
  className: undefined,
  Icon: CloudUploadIcon,
  accept: undefined,
  message: '',
};

export default Dropzone;
